// @flow

import _ from 'lodash';
import type { ComponentInfo } from 'rgs-knockout/types';

export type TChildNodes = NodeList<Node> | null;

export interface TBaseViewModel {
	getChildNodes (allNodes: any, tagName: string): any
}

// TODO: Переместить в более удобное место
// TODO: применить в AdaptiveTableViewModel
//       ko-component-adaptive-table/js/view-model.js
export default class BaseViewModel<TOptions> implements TBaseViewModel {
	_options: TOptions;
	params: {
		props: TOptions
	};
	elementContent: ComponentInfo;

	constructor (params: { props: TOptions }, elementContent: ComponentInfo) {
		this.params = params;
		this._options = params.props
			? (_.isFunction(params.props) ? params.props() : params.props)
			: params || {};
		this.elementContent = elementContent;
	}

	getChildNodes (tagName: string): TChildNodes {
		const lowerTagName = tagName.toLowerCase();

		const node = _.find(this.elementContent.templateNodes, (node) => {
			return node.tagName && node.tagName.toLowerCase() === lowerTagName;
		});

		return node ? [...node.childNodes] : null;
	}
}
